module.exports = __webpack_public_path__ + "img/cases.a70b56d7.webp";